import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DropzoneDirective} from "./dropzone.directive";
import { DropzoneService } from '@app/core/services/dropzone.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [DropzoneDirective],
  exports: [DropzoneDirective],
  providers:[DropzoneService]
})
export class DropzoneModule { }
